import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { WallsType } from '@search/filter-enums/enums/WallsType';
import { WallsTypeFilter } from '../../../../models/Filter';

interface IWallsButtonFilterView {
    filter: WallsTypeFilter;
    handleChange: (value: WallsTypeFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<WallsType>[] = [
    { label: 'Кирпич', value: WallsType.BRICK },
    { label: 'Монолит', value: WallsType.MONOLITH },
    { label: 'Панель', value: WallsType.PANEL },
    { label: 'Кирпич-монолит', value: WallsType.BRICK_MONOLITH },
    { label: 'Блок', value: WallsType.BLOCK },
    { label: 'Дерево', value: WallsType.WOOD }
];

export const DesktopWallsButtonFilterView: React.FC<IWallsButtonFilterView> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: WallsType) => {
        const filters = new Set(filter.walls);

        filters[value ? 'add' : 'delete'](optionType);
        handleChange(new WallsTypeFilter(Array.from(filters)));
    }, [ handleChange, filter.walls ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.walls.includes(value)}
                        onChange={v => onChange(v, value)}
                        variant='filter'
                        dataTest='walls'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
